/* unplugin-vue-components disabled */import { render } from "./SubPoolOffboarding.vue?vue&type=template&id=3dbc9bfb"
import script from "./SubPoolOffboarding.vue?vue&type=script&lang=js"
export * from "./SubPoolOffboarding.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__